<div
  class="flex flex-col w-full min-w-0 sm:absolute sm:inset-0 sm:overflow-hidden"
>
  <mat-drawer-container class="flex-auto sm:h-full">
    <!-- Drawer sm:w-96 -->
    <mat-drawer
      class="dark:bg-gray-900"
      [ngClass]="{ 'w-full lg:w-3/4': drawerOpened }"
      [autoFocus]="false"
      [position]="drawerPosition"
      [mode]="drawerMode"
      [opened]="drawerOpened"
      #drawer
    >
      <!-- Main -->
      <div *ngIf="cAsset && cAsset.ip">
        <asset-details
          [cAsset]="cAsset"
          (toggleFn)="toggleChange($event)"
        ></asset-details>
      </div>
    </mat-drawer>
    <!-- Drawer content -->
    <!--<mat-drawer-content class="flex flex-col " fuseScrollbar>
            <div class="w-auto rounded-2xl" fuseScrollbar>
                <stable aria-label="Assets Table" role="table" [sTableOptions]="deviTableOptions"
                        (hyperlinkCallback)="linkClick($event)"></stable>
            </div>
        </mat-drawer-content>-->
    <mat-drawer-content class="h-full">
      <div>
        <stable
          aria-label="Assets Table"
          role="table"
          [sTableOptions]="deviTableOptions"
        ></stable>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</div>

